<script setup>
import { useCountry } from '@/mixins/useCountry'

const country = useCountry()

const props = defineProps({
  linkFamily: {
    type: Object,
    required: true,
  },
})

const filteredItems = props.linkFamily.items.filter(item => {
  if (item.localesExcept && item.localesExcept.includes(country)) { return false; }
  if (item.localesOnly && !item.localesOnly.includes(country)) { return false; }
  return true;
});
</script>

<template>
  <div class="link-family">
    <h3
      class="mb-3 lg:mb-4 text-light"
      role="heading"
      aria-level="3"
    >
      {{ linkFamily.title }}
    </h3>
    <div class="flex flex-col text-light">
      <template
        v-for="item in filteredItems"
        :key="item"
      >
        <template v-if="item.href">
          <a
            :href="item.href"
            class="table py-1 no-decoration leading-sm"
            target="_blank"
          >
            {{ item.label }}
          </a>
        </template>
        <template v-else>
          <router-link
            :to="item.linkTo"
            class="table py-1 no-decoration leading-sm"
          >
            {{ item.label }}
          </router-link>
        </template>
      </template>
    </div>
  </div>
</template>
